export interface Product {
  id: string;
  name: string;
  brand: string;
  category: string;
  price: number;
  originalPrice: number;
  image: string;
  badge?: string;
  rating: number;
  sales: number;
}

export const allProducts: Product[] = [
  {
    id: 'p1', name: '爱他美 白金版 幼儿配方奶粉 3段 900g', brand: '爱他美', category: 'milk-powder',
    price: 268, originalPrice: 398, rating: 4.9, sales: 28600,
    image: 'https://readdy.ai/api/search-image?query=Aptamil%20Premium%20infant%20formula%20can%20on%20clean%20white%20background%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20minimalist%20composition&width=600&height=600&seq=prod-p1&orientation=squarish',
    badge: '爆款',
  },
  {
    id: 'p2', name: 'a2 Platinum 婴幼儿配方奶粉 2段 900g', brand: 'a2', category: 'milk-powder',
    price: 289, originalPrice: 428, rating: 4.8, sales: 19200,
    image: 'https://readdy.ai/api/search-image?query=a2%20Platinum%20baby%20formula%20tin%20on%20white%20surface%2C%20clean%20minimal%20product%20photography%2C%20soft%20natural%20light&width=600&height=600&seq=prod-p2&orientation=squarish',
    badge: '进口',
  },
  {
    id: 'p3', name: '花王 Merries 妙而舒 纸尿裤 L码 54片', brand: '花王', category: 'diapers',
    price: 129, originalPrice: 189, rating: 4.9, sales: 52300,
    image: 'https://readdy.ai/api/search-image?query=Merries%20diaper%20pack%20on%20white%20background%2C%20soft%20product%20photography%2C%20clean%20minimal%20style&width=600&height=600&seq=prod-p3&orientation=squarish',
    badge: '热卖',
  },
  {
    id: 'p4', name: '贝亲 宽口径PPSU奶瓶 240ml', brand: '贝亲', category: 'feeding',
    price: 99, originalPrice: 158, rating: 4.7, sales: 38500,
    image: 'https://readdy.ai/api/search-image?query=Pigeon%20baby%20bottle%20PPSU%20on%20white%20background%2C%20clean%20product%20photography%2C%20minimalist&width=600&height=600&seq=prod-p4&orientation=squarish',
  },
  {
    id: 'p5', name: 'LEGO 得宝系列 创意拼砌盒 大颗粒积木', brand: '乐高', category: 'toys',
    price: 199, originalPrice: 299, rating: 4.8, sales: 15100,
    image: 'https://readdy.ai/api/search-image?query=LEGO%20Duplo%20creative%20bricks%20box%20on%20white%20background%2C%20colorful%20blocks%2C%20clean%20product%20photography&width=600&height=600&seq=prod-p5&orientation=squarish',
    badge: '新品',
  },
  {
    id: 'p6', name: 'Nike 婴童 Air Max 运动鞋 学步鞋', brand: '耐克', category: 'kids-clothing',
    price: 259, originalPrice: 399, rating: 4.6, sales: 8900,
    image: 'https://readdy.ai/api/search-image?query=Nike%20baby%20toddler%20sneakers%20on%20white%20background%2C%20cute%20small%20shoes%2C%20product%20photography&width=600&height=600&seq=prod-p6&orientation=squarish',
  },
  {
    id: 'p7', name: '贝拉米 有机婴儿米粉 4+个月 225g', brand: '贝拉米', category: 'milk-powder',
    price: 68, originalPrice: 98, rating: 4.7, sales: 21300,
    image: 'https://readdy.ai/api/search-image?query=Bellamy%20organic%20baby%20rice%20cereal%20box%20on%20white%20surface%2C%20clean%20product%20photography&width=600&height=600&seq=prod-p7&orientation=squarish',
  },
  {
    id: 'p8', name: 'Babycare 婴儿湿巾 手口专用 80抽×6包', brand: 'Babycare', category: 'diapers',
    price: 59, originalPrice: 89, rating: 4.8, sales: 67200,
    image: 'https://readdy.ai/api/search-image?query=Babycare%20baby%20wipes%20pack%20on%20white%20background%2C%20clean%20minimal%20photography&width=600&height=600&seq=prod-p8&orientation=squarish',
    badge: '囤货装',
  },
  {
    id: 'p9', name: 'Fisher-Price 费雪 婴儿健身架 脚踏钢琴', brand: '费雪', category: 'toys',
    price: 329, originalPrice: 499, rating: 4.8, sales: 12400,
    image: 'https://readdy.ai/api/search-image?query=Fisher%20Price%20baby%20gym%20play%20mat%20with%20piano%20on%20white%20background%2C%20colorful%20product%20photo&width=600&height=600&seq=prod-p9&orientation=squarish',
  },
  {
    id: 'p10', name: 'Mama&Kids 婴儿沐浴露 无添加 460ml', brand: 'Mama&Kids', category: 'baby-care',
    price: 168, originalPrice: 238, rating: 4.9, sales: 27600,
    image: 'https://readdy.ai/api/search-image?query=Mama%20and%20Kids%20baby%20body%20wash%20bottle%20on%20white%20background%2C%20clean%20product%20photography&width=600&height=600&seq=prod-p10&orientation=squarish',
    badge: '口碑',
  },
  {
    id: 'p11', name: '昆塔斯 Q3 婴儿推车 轻便折叠', brand: '昆塔斯', category: 'feeding',
    price: 1299, originalPrice: 1999, rating: 4.7, sales: 4300,
    image: 'https://readdy.ai/api/search-image?query=Quintus%20baby%20stroller%20lightweight%20foldable%20on%20white%20background%2C%20product%20photography&width=600&height=600&seq=prod-p11&orientation=squarish',
  },
  {
    id: 'p12', name: 'mini rodini 有机棉 婴儿连体衣 北欧风', brand: 'Mini Rodini', category: 'kids-clothing',
    price: 219, originalPrice: 359, rating: 4.5, sales: 5600,
    image: 'https://readdy.ai/api/search-image?query=Mini%20Rodini%20organic%20cotton%20baby%20onesie%20on%20white%20background%2C%20Scandinavian%20design%2C%20product%20photo&width=600&height=600&seq=prod-p12&orientation=squarish',
  },
  {
    id: 'p13', name: '惠氏 S-26 金装 幼儿配方奶粉 4段 900g', brand: '惠氏', category: 'milk-powder',
    price: 238, originalPrice: 358, rating: 4.8, sales: 32100,
    image: 'https://readdy.ai/api/search-image?query=Wyeth%20S26%20gold%20infant%20formula%20can%20on%20white%20background%2C%20clean%20product%20photography&width=600&height=600&seq=prod-p13&orientation=squarish',
  },
  {
    id: 'p14', name: '艾维诺 Aveeno 婴儿润肤乳 227g', brand: 'Aveeno', category: 'baby-care',
    price: 79, originalPrice: 119, rating: 4.7, sales: 45300,
    image: 'https://readdy.ai/api/search-image?query=Aveeno%20baby%20lotion%20bottle%20on%20white%20background%2C%20clean%20product%20photography%2C%20minimal&width=600&height=600&seq=prod-p14&orientation=squarish',
  },
  {
    id: 'p15', name: '面包超人 儿童早教益智玩具 六面体', brand: '面包超人', category: 'toys',
    price: 158, originalPrice: 249, rating: 4.8, sales: 18200,
    image: 'https://readdy.ai/api/search-image?query=Anpanman%20baby%20educational%20cube%20toy%20on%20white%20background%2C%20colorful%20product%20photo&width=600&height=600&seq=prod-p15&orientation=squarish',
    badge: '人气',
  },
  {
    id: 'p16', name: '帮宝适 一级帮 纸尿裤 XL码 48片', brand: '帮宝适', category: 'diapers',
    price: 139, originalPrice: 199, rating: 4.8, sales: 48700,
    image: 'https://readdy.ai/api/search-image?query=Pampers%20premium%20diapers%20pack%20on%20white%20background%2C%20clean%20product%20photography&width=600&height=600&seq=prod-p16&orientation=squarish',
  },
];

export const getProductsByCategory = (categorySlug: string): Product[] => {
  return allProducts.filter((p) => p.category === categorySlug);
};

export const getHotProducts = (): Product[] => {
  return allProducts.filter((p) => p.badge === '爆款' || p.badge === '热卖').slice(0, 6);
};

export const getProductById = (id: string): Product | undefined => {
  return allProducts.find((p) => p.id === id);
};